import { AxiosError } from 'axios';
import { types, flow, Instance } from 'mobx-state-tree';
import axios from 'utils/axios.config';
import { withAlertStore } from 'components/Core/CustomAlert/store';
import { ErrorData, IResponse } from 'types/common';
import { IElasticSyncRequest, IElasticSyncResponse } from './types';

const { model, frozen, maybeNull } = types;

export const ElasticStore = model('ElasticStore', {
  elasticSyncData: maybeNull(frozen<IElasticSyncResponse>()),
})
  .extend(withAlertStore)
  .actions((self) => ({
    setElasticSyncData(data: IElasticSyncResponse | null) {
      self.elasticSyncData = data;
    },
  }))
  .actions((self) => ({
    errorHandling({ response }: AxiosError<IResponse<ErrorData>>) {
      const msg = response?.data.message || 'Internal server error';
      self.alertStore.showAlert(msg);
      throw new Error(msg);
    },
  }))
  .actions((self) => ({
    syncBrandProductsToElastic: flow(function* ({ brandId }: IElasticSyncRequest) {
      return yield axios
        .post('elasticsync/sync-brand-products-to-search-v2', {
          brandId,
        })
        .then(({ data }) => {
          self.setElasticSyncData(data);
          self.alertStore.showAlert('Elastic sync completed successfully', 'success');
          return data;
        })
        .catch(self.errorHandling);
    }),
  }));

export type IElasticStore = Instance<typeof ElasticStore>;
